import(/* webpackMode: "eager" */ "C:\\Verasoft\\KORVUE-XL\\rxl\\src\\app\\not-found.tsx");
